import { Col, Row, Spinner } from 'react-bootstrap'
import { House, Truck } from 'phosphor-react'
import { formatDate } from '../../../utils/format'

import styles from './styles.module.css'

const DeliveryReports = ({ reports, isLoading, requestId, deliveryStartDate }) => {
  return (
    <Col
      className={`${styles.reportsContainer} d-flex flex-column justify-content-center align-items-start`}
    >
      <div style={{ width: '100%' }}>
        {isLoading ? (
          <Spinner
            animation="border"
            size="sm"
            style={{
              color: '#fff',
              marginRight: 10,
            }}
          />
        ) : (
          <div>
            <div>
              {reports[0]?.request_id === Number(requestId) ? (
                <Report
                  color="#DB222A"
                  report={{
                    description: 'Motorista está a caminho da sua entrega',
                    created_at: reports[0]?.created_at,
                  }}
                />
              ) : (
                <Report color="#053C5E" report={reports[0]} />
              )}
            </div>
            {reports.slice(1, reports.length).map((report, index) => (
              <div key={index}>
                <Report color="#C4C4C4" report={report} />
              </div>
            ))}

            <Report
              color="#C4C4C4"
              report={{
                description: 'Caminhão em carregamento na base',
                created_at: deliveryStartDate,
              }}
              isFirstReport={true}
            />
          </div>
        )}
      </div>
    </Col>
  )
}

export default DeliveryReports

const Report = ({ color, report, isFirstReport }) => {
  return (
    <>
      <Row>
        <Col className="col-2 text-center">
          <div className={styles.iconCircle} style={{ backgroundColor: color }}>
            {isFirstReport ? (
              <House color="white" size="30px" weight="bold" />
            ) : (
              <Truck color="white" size="30px" />
            )}
          </div>
          {!isFirstReport && <p className={styles.verticalLine}></p>}
        </Col>
        <Col className="col-10 d-flex flex-column align-items-start justify-content-center">
          <span style={{ fontSize: 12 }}>{formatDate(report?.created_at)}</span>
          <span style={{ fontSize: 18, fontWeight: 'bold' }}>{report?.description}</span>
        </Col>
      </Row>
      {!isFirstReport && (
        <Row>
          <Col className="col-2">
            <p className={styles.verticalLinee}></p>
          </Col>
        </Row>
      )}
    </>
  )
}
